export const Navlinks = [
  {
    id: 1,
    name: "Home",
    link: "/",
  },
  {
    id: 2,
    name: "Hotels",
    link: "/hotels",
  },
  {
    id: 3,
    name: "About us",
    link: "/#about",
  },
];